import axios from 'axios';
import { useEffect, useState } from 'react';
import { EventLog } from '../../../types/shared';
import { format } from 'date-fns';
import { useParams } from 'react-router-dom';
import {
    route,
    API_ENDPOINTS,
    WidthConstrainedContainer,
    Spinner,
    Card,
    CardBody,
    SubTitle,
    StringHelpers,
    useLangContext,
    DateFormats,
    customToast,
    Variants
} from 'carrier-fe';

function ClaimEventLog() {
    const { fields, responses, crud } = useLangContext();
    const { claimId } = useParams();
    const [eventLogs, setEventLogs] = useState<EventLog[]>([]);
    const [isLoading, setIsLoading] = useState<boolean>(false);

    useEffect(() => {
        const fetchData = async () => {
            try {
                setIsLoading(true);
                const response = await axios.get(
                    route(API_ENDPOINTS.REGISTRATION.CLAIM.EVENT_LOG, {
                        claimId: String(claimId),
                    })
                );
                setEventLogs(response.data.data || []);
            } catch (err: any) {
                customToast({
                    title:
                        err?.response?.data?.message ||
                        'An error occurred.',
                    variant: Variants.Danger,
                })
            } finally {
                setIsLoading(false);
            }
        };

        fetchData();
    }, [claimId]);

    return (
        <WidthConstrainedContainer>
            <div>
                {isLoading ? (
                    <div className="d-flex justify-content-center align-items-center vh-100">
                        <Spinner />
                    </div>
                ) : (
                    <Card>
                        <CardBody>
                            <SubTitle 
                                className="mb-3 w-100" 
                                style={{ color: '#464C5E' }} 
                                title={`${crud?.models?.claim || 'Claim'} ${crud?.sub_titles?.event_logs || 'Event Logs'}`} 
                            />
                            <div className="table-responsive">
                                {eventLogs.length > 0 ?
                                    <table className="table w-100">
                                        <thead>
                                            <tr>
                                                <th className="border border-gray-300 px-4 py-2">{StringHelpers.title(fields?.event_at || 'Date')}</th>
                                                <th className="border border-gray-300 px-4 py-2">{StringHelpers.title(fields?.event_name || 'Event')}</th>
                                                <th className="border border-gray-300 px-4 py-2">{StringHelpers.title(fields?.user_name || 'User')}</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {(
                                                eventLogs.map((log, index) => (
                                                    <tr key={`${log.event_name}-${log.created_at}-${index}`}>
                                                        <td className="border border-gray-300 px-4 py-2">
                                                            {format(new Date(log.created_at), DateFormats.DATETIME_SHORT)}
                                                        </td>
                                                        <td className="border border-gray-300 px-4 py-2">
                                                            {log.display_event_name || '-'}
                                                        </td>
                                                        <td className="border border-gray-300 px-4 py-2">
                                                            {log.display_causer || '-'}
                                                        </td>
                                                    </tr>
                                                ))
                                            )}
                                        </tbody>
                                    </table> : (
                                        <p>
                                            {StringHelpers.replace(responses?.errors?.no_results_found, ':attribute', responses?.models?.event_log)}
                                        </p>

                                    )}
                            </div>
                        </CardBody>
                    </Card>
                )}
            </div>
        </WidthConstrainedContainer>
    );
}

export default ClaimEventLog;
